import React from 'react';
import PropTypes from "prop-types";
import {DateFormatter, DateParser} from "../../services/date";
import OfferService from "../../services/offers";

import KeyValueHorizontal from "../../components/KeyValueHorizontal";

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import HomeIcon from '@mui/icons-material/Home';
import VisibilityIcon from '@mui/icons-material/Visibility';


const StatusLabel = (props) => {
    const {label, bgcolor, color} = props;

    return (
        <Box sx={{
            borderRadius: 1,
            bgcolor: bgcolor || 'primary.main',
            px: 2,
            fontSize: 'caption.fontSize',
            fontWeight: 500,
            color: color || "white"
        }}>
            {label}
        </Box>
    )
};

StatusLabel.propTypes = {
    label: PropTypes.string.isRequired,
    bgcolor: PropTypes.string,
    color: PropTypes.string,
};

const OfferCard = props => {
    const {offer, onShow, onModify, onDelete} = props;

    const {
        id,
        titleIt,
        startDate,
        endDate,
        photo,
        price,
        minPeople,
        minNight,
        petsAllowed,
        apartment,
    } = offer;

    const from = DateParser.safeParseISO(startDate);
    const to = DateParser.safeParseISO(endDate);

    const isExpired = OfferService.utils.offerIsExpired(offer);

    const handleShow = () => onShow(offer);
    const handleEdit = () => onModify(offer, true);
    const handleCopy = () => onModify(offer, false);
    const handleDelete = () => onDelete(id);

    return (
        <Card>
            <CardHeader
                title={titleIt}
                subheader={`${DateFormatter.shortString(from)} - ${DateFormatter.shortString(to)}`}
            />
            <CardMedia
                component="img"
                alt={titleIt}
                height="230px"
                image={photo}
                title={titleIt}/>

            <CardContent>
                <Box sx={{pb: 1, display: "flex", alignItems: "center"}}>
                    <Box sx={{pr: 1}}>
                        <HomeIcon/>
                    </Box>
                    <Typography variant="subtitle2">
                        {apartment.name}
                    </Typography>
                </Box>

                <Box sx={{pb: 3}}>
                    <KeyValueHorizontal horizontalDivider={true}
                                        pairs={[
                                            ["Min. persone", minPeople],
                                            ["Min. notti", minNight],
                                            ["Animali", petsAllowed ? "Si" : "No"]
                                        ]}/>
                </Box>

                <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
                    {
                        OfferService.utils.offerIsExpired(offer)
                            ? <StatusLabel label="Scaduta" bgcolor="error.dark"/>
                            : <StatusLabel label="Attiva" bgcolor="success.dark"/>
                    }
                    <Typography gutterBottom variant="h5" align="right">
                        <Box component="span" sx={{pr: 1, color: "text.primary", fontSize: "body2.fontSize"}}>
                            Prezzo
                        </Box>
                        {`${price} €`}
                    </Typography>
                </Box>
            </CardContent>

            <CardActions disableSpacing>
                <Button size="small" onClick={handleCopy} sx={{mr: "auto"}}>
                    Riproponi
                </Button>
                <IconButton aria-label="Visualizza" onClick={handleShow}>
                    <VisibilityIcon/>
                </IconButton>
                {
                    !isExpired &&
                    <IconButton aria-label="Modifica" onClick={handleEdit}>
                        <EditIcon/>
                    </IconButton>
                }
                <IconButton aria-label="Elimina" onClick={handleDelete}>
                    <DeleteIcon/>
                </IconButton>
            </CardActions>
        </Card>
    )
};

OfferCard.propTypes = {
    offer: PropTypes.object.isRequired,
    onShow: PropTypes.func.isRequired,
    onModify: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
};

export default OfferCard;